import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";

 // app config
 import AppConfig from 'Constants/AppConfig';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import { RctCard, RctCardContent } from 'Components/RctCard/index';


import { 
    fetchPlayerWedge,
    fetchWedgeplay,
    deleteWedgeplay
 } from 'Actions';

 import AddItem from '../../../technologyreport/wedgeplay/component/addform';
 import EditItem from '../../../technologyreport/wedgeplay/component/editform';

 import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
 import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class FsdriverItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {  
            student: this.props.data.student, 
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,
            listdiv:true,
            reportdiv:false,
            allreports:[],
            filecnt:0,
            adddiv:false,
            frmreport:this.props.data.frmreport,
            editdiv:false,
            alllstdiv1:false,
            eid:'', 
            carryform: [{ carry : ""}],
            cntcry:1,
            clubform: [{ club : ""}],
            cntclub:1,
            ballform: [{ ball : ""}],
            cntball:1,
            rateform: [{ rate : ""}],
            cntrate:1,
            loftform: [{ loft : ""}],
            cntloft:1,
            dynamicform: [{ dynamic : ""}],
            cntdynamic:1,
            launchform: [{ launch : ""}],
            cntlaunch:1,
            landingform: [{ landing : ""}],
            cntlanding:1,  
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
        this.onBacksection = this.onBacksection.bind(this); 
        this.onAddSession = this.onAddSession.bind(this);
        this.onListSession = this.onListSession.bind(this); 
        this.deleteForm = this.deleteForm.bind(this); 
    }

    

    onPrevSection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerWedge(student, stdate, eddate);

        this.setState({
            reportdiv:false,
            adddiv:false,
            alllstdiv1:false,
            listdiv:true, 
        }); 
    }

    onAddSession() {
        
		this.setState({ 
         listdiv:false,
         adddiv:true,
      });
    }
    
    onListSession() {   

		this.setState({ 
         sellst:1,   
         alllstdiv1:true,   
         listdiv:false,
         adddiv:false,
      });
    }

    onBacksection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchPlayerWedge(student, stdate, eddate);

        this.setState({ 
            alllstdiv1:false,  
            editdiv:false,
            adddiv:false,
            reportdiv:false,
            listdiv:true
        });
    }

    editAssessment(gid){
        this.props.fetchWedgeplay(gid).then((data) => {   
            var resdata=data.data;
            
            var allcarry=resdata[0].gwp_carry.split(",");
            var trcryobj=[]; 
            var trcrycnt=1;
            if(allcarry.length!=0){
               {allcarry.map((teamval) => (   
                  trcryobj.push({
                     carry: teamval
                  })
               ))}
               trcrycnt=allcarry.length;
            }else{
               trcryobj.push({
                  carry: ''
               })
            }

            var allclub=resdata[0].gwp_clubspeed.split(",");
            var trclubobj=[]; 
            var trclubcnt=1;
            if(allclub.length!=0){
               {allclub.map((teamval) => (   
                  trclubobj.push({
                     club: teamval
                  })
               ))}
               trclubcnt=allclub.length;
            }else{
               trclubobj.push({
                  club: ''
               })
            }

            var allball=resdata[0].gwp_ballspeed.split(",");
            var trballobj=[]; 
            var trballcnt=1;
            if(allball.length!=0){
               {allball.map((teamval) => (   
                  trballobj.push({
                     ball: teamval
                  })
               ))}
               trballcnt=allball.length;
            }else{
               trballobj.push({
                  ball: ''
               })
            }

            var allrate=resdata[0].gwp_spinrate.split(",");
            var trrateobj=[]; 
            var trratecnt=1;
            if(allrate.length!=0){
               {allrate.map((teamval) => (   
                  trrateobj.push({
                     rate: teamval
                  })
               ))}
               trratecnt=allrate.length;
            }else{
               trrateobj.push({
                  rate: ''
               })
            }

            var allloft=resdata[0].gwp_spinloft.split(",");
            var trloftobj=[]; 
            var trloftcnt=1;
            if(allloft.length!=0){
               {allloft.map((teamval) => (   
                  trloftobj.push({
                     loft: teamval
                  })
               ))}
               trloftcnt=allloft.length;
            }else{
               trloftobj.push({
                  loft: ''
               })
            }

            var alldynm=resdata[0].gwp_dynamicloft.split(",");
            var trdynmobj=[]; 
            var trdynmcnt=1;
            if(alldynm.length!=0){
               {alldynm.map((teamval) => (   
                  trdynmobj.push({
                     dynamic: teamval
                  })
               ))}
               trdynmcnt=alldynm.length;
            }else{
               trdynmobj.push({
                  dynamic: ''
               })
            }

            var alllunh=resdata[0].gwp_launchangle.split(",");
            var trlunhobj=[]; 
            var trlunhcnt=1;
            if(alllunh.length!=0){
               {alllunh.map((teamval) => (   
                  trlunhobj.push({
                     launch: teamval
                  })
               ))}
               trlunhcnt=alllunh.length;
            }else{
               trlunhobj.push({
                  launch: ''
               })
            }

            var allland=resdata[0].gwp_landingangle.split(",");
            var trlandobj=[]; 
            var trlandcnt=1;
            if(allland.length!=0){
               {allland.map((teamval) => (   
                  trlandobj.push({
                     landing: teamval
                  })
               ))}
               trlandcnt=allland.length;
            }else{
               trlandobj.push({
                  landing: ''
               })
            }
            

            this.setState({ 
                seldate:resdata[0].gwp_date,  
                student:resdata[0].gwp_userID, 
                eid:resdata[0].gwpID, 
                carryform: trcryobj,
                cntcry:trcrycnt, 
                clubform: trclubobj,
                cntclub:trclubcnt,  
                ballform: trballobj,
                cntball:trballcnt,  
                rateform:trrateobj,
                cntrate:trratecnt,
                loftform:trloftobj,
                cntloft:trloftcnt,
                dynamicform:trdynmobj,
                cntdynamic:trdynmcnt,
                launchform:trlunhobj,
                cntlaunch:trlunhcnt,
                landingform:trlandobj,
                cntlanding:trlandcnt,
            });

            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                alllstdiv1:false,
                editdiv:true,
       
            });

        });
    }

    deleteForm(data){
      this.data = data;
      this.student=this.state.student;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteWedgeplay(this.data);
            var student=this.student;
            this.props.fetchPlayerWedge(student, '', '');
        }
    }


render() {
      
    const { playertechwedge, loading} = this.props; 
    const stdrole = localStorage.getItem('stdrole');  
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "name", label: "NAME" },
        { name: "cdate", label: "DATE" },
        { name: "action", label: "ACTION" },
        { name: "action1", label: "ACTION1" },
      
    ];
    const tabledata=playertechwedge.map((assmntval,idx) => {     
                 const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.gwpID)}><EditOutlinedIcon/></IconButton>;
                 const dbtn=<IconButton className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.gwpID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
            no:idx+1,
            name: assmntval.student,
            cdate: assmntval.cdate,
            action: ebtn,
            action1:dbtn,
            
            }
    }); 
    const styles = {
        table: {
            border: "2px solid rgb(0, 0, 0)",
            borderColor:"rgb(0 0 0 / 49%)",
            borderStyle:"solid",
            color:"#000"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight: "500"
        },
        tabletrtdleft:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px"
        },
        tabletrtdhead:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight:"bold",
            textAlign:"center"
        }
    };

      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> FS WEDGE PLAY </h1>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                    <div className="ddd">
                    {stdrole==0 ? <div className="float-left"><a onClick={this.onAddSession} style={{color:"blue"}}><span class="icon-plus"></span> Add</a> <a style={{color:"orange", paddingLeft:"10px"}} onClick={this.onListSession}><span class="icon-list"></span> List</a></div> : ""}
                        <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><KeyboardDoubleArrowLeftIcon aria-hidden="true" />  Back To Technology</Button></div>
                        {this.state.frmreport==1?<div className="float-left"><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Report</Button></div>:''}
                    </div>
                </div>
                {this.state.listdiv && 
                    <div className="shop-grid">
                        <div className="row">
                        {playertechwedge.map((product, key) => (
                            <div className="col-sm-6 col-md-4 col-xl-3" key={key}>
                                <RctCard>
                                    <RctCardContent>
                                    
                                    <div className="rpoduct-detail">
                                        <h2 className="text-center">{product.cdate}</h2>
                                        {/* <h4 className="mb-15 text-center">{product.student}</h4> */}
                                        <div className="table-responsive">
                                        <table className="table align-items-center table-flush" style={styles.table}>  
                                        <tbody>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>CLUB</td>
                                                <td style={styles.tabletrtd}><strong>{product.gwp_selclub}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>CARRY</td>
                                                <td style={styles.tabletrtd}><strong>{product.carry}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>CLUB SPEED</td>
                                                <td style={styles.tabletrtd}><strong>{product.clubspeed}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>BALL SPEED</td>
                                                <td style={styles.tabletrtd}><strong>{product.ballspeed}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>SPIN RATE</td>
                                                <td style={styles.tabletrtd}><strong>{product.spinrate}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>SPIN LOFT</td>
                                                <td style={styles.tabletrtd}><strong>{product.spinloft}</strong></td>
                                            </tr> 
                                            <tr>
                                                <td style={styles.tabletrtdleft}>DYNAMIC LOFT</td>
                                                <td style={styles.tabletrtd}><strong>{product.dynamicloft}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>LAUNCH ANGLE</td>
                                                <td style={styles.tabletrtd}><strong>{product.launchangle}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>LANDING ANGLE</td>
                                                <td style={styles.tabletrtd}><strong>{product.landing}</strong></td>
                                            </tr>
                                            <tr>
                                                <td style={styles.tabletrtdleft}>NOTES</td>
                                                <td style={styles.tabletrtd}>{product.gwp_notes}</td>
                                            </tr> 
                                        </tbody>
                                        </table>  
                                        </div>     
                                        
                                    </div>
                                    </RctCardContent>
                                </RctCard>
                            </div>
                        ))}
                        </div>
                    </div>
                }

                {this.state.alllstdiv1 &&
                    <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="List" backtoadd onClick={this.onPrevSection} fullBlock>
                            <MUIDataTable
                                data={tabledata}
                                columns={columns}
                                options={options}
                            />
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.adddiv &&
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }

                {this.state.editdiv &&
                    <EditItem onClick={this.onBacksection} data={this.state}/>
                }

                <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'wedge play'}
                />

            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention}) => {
   
    const { playertechwedge, loading } = playerintervention;
    
    return { playertechwedge, loading };   
}


export default connect(mapStateToProps, {
    fetchPlayerWedge,
    fetchWedgeplay,
    deleteWedgeplay
})(FsdriverItems);
